import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54714e78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "hits" }
const _hoisted_4 = {
  key: 0,
  class: "modified-at"
}
const _hoisted_5 = { class: "author" }
const _hoisted_6 = { class: "author-name" }
const _hoisted_7 = { class: "created-at" }
const _hoisted_8 = {
  key: 0,
  class: "modify-actions"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "·", -1))
const _hoisted_10 = { class: "tags" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = {
  key: 0,
  class: "series-container"
}
const _hoisted_13 = { class: "series-title" }
const _hoisted_14 = { class: "series-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "write-comment" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 댓글 남기기 ")
const _hoisted_19 = {
  key: 0,
  class: "guest-comment-info"
}
const _hoisted_20 = { class: "login-guide" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode("이름과 비밀번호 없이 댓글을 달기 위해서는 ")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("로그인")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("이 필요합니다.")
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "comments" }
const _hoisted_26 = { class: "counts" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "·", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "empty-comment-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_account_profile_image_button = _resolveComponent("account-profile-image-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_post_viewer = _resolveComponent("post-viewer")!
  const _component_simple_comment_item = _resolveComponent("simple-comment-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.post.title), 1),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(" 조회수 " + _toDisplayString(_ctx.post.hits) + " 회 ", 1),
        (_ctx.longCreateAt !== _ctx.longLastModifiedAt)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.longLastModifiedAt) + " 마지막으로 수정됨 ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_account_profile_image_button, {
          class: "author-profile-image",
          "simple-account": _ctx.post.author
        }, null, 8, ["simple-account"]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.post.author?.name), 1),
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(_ctx.longCreateAt) + " ", 1),
          (_ctx.isMyPost)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _createElementVNode("a", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.modifyPost && _ctx.modifyPost(...args)))
                }, "수정"),
                _hoisted_9,
                _createElementVNode("a", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deletePost && _ctx.deletePost(...args)))
                }, "삭제")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "tag-item",
              key: tag
            }, _toDisplayString(tag), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_ctx.series)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.series.title), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("ol", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.series.posts, (seriesPost) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: seriesPost.postUrl,
                    to: {path: `/${_ctx.blogId}/posts/${seriesPost.postUrl}`},
                    custom: ""
                  }, {
                    default: _withCtx(({ route, href, navigate }) => [
                      _createElementVNode("li", null, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.$route.fullPath === route.fullPath ? 'series-active' : null),
                          onClick: navigate
                        }, [
                          _createElementVNode("a", { href: href }, _toDisplayString(seriesPost.title), 9, _hoisted_16)
                        ], 10, _hoisted_15)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_post_viewer, {
        content: _ctx.post.content
      }, null, 8, ["content"])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newComment) = $event)),
        placeholder: "댓글 내용을 입력하세요."
      }, null, 512), [
        [_vModelText, _ctx.newComment]
      ]),
      (!_ctx.isLoggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.guestCommentName) = $event)),
              placeholder: "이름"
            }, null, 512), [
              [_vModelText, _ctx.guestCommentName]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.guestCommentPassword) = $event)),
              placeholder: "비밀번호",
              type: "password",
              autocomplete: "off"
            }, null, 512), [
              [_vModelText, _ctx.guestCommentPassword]
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("span", null, [
                _hoisted_21,
                _createVNode(_component_router_link, { to: "/signin" }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 1
                }),
                _hoisted_23
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        disabled: !_ctx.isValidNewComment,
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.writeComment && _ctx.writeComment(...args)))
      }, "댓글 작성", 8, _hoisted_24)
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("span", null, _toDisplayString(_ctx.allCommentCount) + " 개의 댓글", 1),
        _hoisted_27,
        _createElementVNode("span", null, _toDisplayString(_ctx.likeCount) + " 개의 좋아요", 1),
        (_ctx.isLoggedIn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              (!this.isLike)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.likePost && _ctx.likePost(...args)))
                  }, "좋아요 하기"))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.unlikePost && _ctx.unlikePost(...args)))
                  }, "좋아요 취소"))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.comments?.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, " 댓글이 없습니다. "))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment) => {
        return (_openBlock(), _createBlock(_component_simple_comment_item, {
          key: comment.id,
          "simple-comment": comment,
          post: _ctx.post,
          onDeleted: _ctx.commentDeleted,
          onChanged: _ctx.commentChanged
        }, null, 8, ["simple-comment", "post", "onDeleted", "onChanged"]))
      }), 128))
    ])
  ]))
}